import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const uniformAgri: ImportTypeConfig = {
  dateField: {
    labelKey: 'date_milk_production',
    subtractDays: 1,
  },
  dateFormat: { default: 'D/M/YYYY' },
  importType: true,
  instructions: {
    dateInstructionKey: 'select_date_of_milk_production_instruction',
    software: 'UNIFORM-Agri',
  },
  type: 'uniform-agri',
}
